import { IPolicyMotorDetails } from '.';

export const initialPolicyMotorValues: IPolicyMotorDetails = {
  nameOnLicenseEn: '',
  nameOnLicenseAr: '',
  vignetteCode: '',
  vignette: null,
  plateCode: {
    Id: '',
    Code: '',
    Title: '',
  },
  plateNumber: null,
  usageType: {
    Id: '',
    Code: '',
    Title: '',
  },
  bodyType: {
    Id: '',
    Code: '',
    Title: '',
  },
  engineType: {
    Id: '',
    Code: '',
    Title: '',
  },
  make: {
    Id: '',
    Code: '',
    Title: '',
  },
  model: {
    Id: '',
    Code: '',
    Title: '',
  },
  color: {
    Id: '',
    Code: '',
    Title: '',
  },
  yearOfMake: null,
  engine: '',
  weight: null,
  engineSize: null,
  seatingCapacity: null,
  chassis: '',
  horsePower: null,
  carValue: null,
  agencyRepairYear: null,
  depreciationYears: null,
};
